import React, { useState, useEffect } from "react";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  contentKey: string;
  onAccept: (key: string) => void;
  content?: any[];
  isAlreadyAccepted?: boolean;
}


const DeclarationDrawer: React.FC<DrawerProps> = ({
  isOpen,
  onClose,
  contentKey,
  onAccept,
  content = [],
  isAlreadyAccepted = false,
}) => {
  const [isAccepted, setIsAccepted] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsAccepted(isAlreadyAccepted);
    }
  }, [isOpen, isAlreadyAccepted]);

  if (!isOpen) return null;
  const apiContent = content.length > 0 ? content[0] : null;
  const title = apiContent?.heading || "Loading...";
  const text = apiContent?.content || "No content available.";

  const handleAccept = () => {
    if (!isAlreadyAccepted) {
      setIsAccepted(true);
      onAccept(contentKey);
      // Optionally, auto-close the drawer after a delay
      setTimeout(() => {
        onClose();
      }, 1000);
    }
  };

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-30 transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      style={{ zIndex: "calc(var(--z-drawer) + 1)" }}
      onClick={onClose}
    >
      <div
        className={`fixed top-0 right-0 h-full w-4/5 sm:w-1/2 md:w-1/3 lg:w-[400px] overflow-y-auto bg-white p-6 shadow-lg transition-transform duration-300 ease-in-out transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl text-gray-600 hover:text-black"
        >
          &times;
        </button>

        <div className="space-y-6">
          <h2 className="text-xl font-bold text-gray-900">{title}</h2>
          <div className="text-sm text-gray-700">
            {apiContent ? (
              <div dangerouslySetInnerHTML={{ __html: text }} />
            ) : (
              <p>{text}</p>
            )}
          </div>
        </div>

        <div className="mt-6">
          <button
            onClick={handleAccept}
            disabled={isAccepted || isAlreadyAccepted}
            className={`w-full py-2 text-center text-sm font-medium rounded-lg transition-colors duration-300 ${
              isAccepted || isAlreadyAccepted
                ? "bg-green-600 text-white cursor-default"
                : "bg-primaryBlueText text-white hover:opacity-90"
            }`}
          >
            {isAccepted || isAlreadyAccepted ? "Accepted" : "I Accept"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeclarationDrawer;
